import TopTeam from 'components/base/top-team/TopTeam';
import moment from 'moment';
import React from 'react';

const LogisticsStatsPageEight = () => {
  const month = moment().format('MMMM');
  return <TopTeam title={`Top riders for ${month} ...`} />;
};
export default LogisticsStatsPageEight;
